import { get, post, put, del } from './api.js';
import { getSession } from './auth.js';

function adminStrings(app) {
  try {
    return JSON.parse(app.dataset.i18n || '{}');
  } catch (e) {
    return {};
  }
}

function statusLabel(s, status) {
  return (s.status && s.status[status]) || status;
}

function roleLabel(s, role) {
  if (role === 'admin') return s.roleAdmin || 'Administrator';
  return s.roleUser || 'User';
}

function initAdminApp() {
  var app = document.getElementById('admin-app');
  if (!app || app._inited) return;
  app._inited = true;
  var s = adminStrings(app);

  get('/admin/stats').then(function (data) {
    document.getElementById('stat-today').textContent = data.today;
    document.getElementById('stat-week').textContent = data.week;
    document.getElementById('stat-month').textContent = data.month;
    document.getElementById('stat-clients').textContent = data.clients || '—';

    var loading = document.getElementById('admin-upcoming-loading');
    var empty = document.getElementById('admin-upcoming-empty');
    var table = document.getElementById('admin-upcoming-table');
    var tbody = document.getElementById('admin-upcoming-body');

    if (data.upcoming && data.upcoming.length) {
      loading.hidden = true;
      table.hidden = false;
      data.upcoming.forEach(function (b) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<td>' + b.booking_date + '</td><td>' + b.booking_time + '</td><td>' + escapeHtml(b.client_name) + '</td><td>' + escapeHtml(b.service) + '</td><td>' + statusLabel(s, b.status) + '</td>';
        tbody.appendChild(tr);
      });
    } else {
      loading.hidden = true;
      empty.hidden = false;
    }
  }).catch(function () {
    document.getElementById('admin-upcoming-loading').hidden = true;
    document.getElementById('admin-upcoming-empty').hidden = false;
  });

  get('/admin/bookings').then(function (data) {
    var loading = document.getElementById('admin-recent-loading');
    var empty = document.getElementById('admin-recent-empty');
    var table = document.getElementById('admin-recent-table');
    var tbody = document.getElementById('admin-recent-body');

    if (data.bookings && data.bookings.length) {
      loading.hidden = true;
      table.hidden = false;
      data.bookings.slice(0, 10).forEach(function (b) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<td>' + b.booking_date + '</td><td>' + escapeHtml(b.client_name) + '</td><td>' + escapeHtml(b.service) + '</td><td>' + statusLabel(s, b.status) + '</td>';
        tbody.appendChild(tr);
      });
    } else {
      loading.hidden = true;
      empty.hidden = false;
    }
  }).catch(function () {
    document.getElementById('admin-recent-loading').hidden = true;
    document.getElementById('admin-recent-empty').hidden = false;
  });
}

function initAdminBookings() {
  var app = document.getElementById('admin-bookings-app');
  if (!app || app._inited) return;
  app._inited = true;
  var s = adminStrings(app);

  function load() {
    var search = document.getElementById('admin-bookings-search').value;
    var status = document.getElementById('admin-bookings-status').value;
    var params = new URLSearchParams({ search: search, status: status });
    var loading = document.getElementById('admin-bookings-loading');
    var empty = document.getElementById('admin-bookings-empty');
    var table = document.getElementById('admin-bookings-table');
    var tbody = document.getElementById('admin-bookings-body');

    loading.hidden = false;
    table.hidden = true;
    empty.hidden = true;
    tbody.innerHTML = '';

    get('/admin/bookings?' + params.toString()).then(function (data) {
      loading.hidden = true;
      if (data.bookings && data.bookings.length) {
        table.hidden = false;
        data.bookings.forEach(function (b) {
          var tr = document.createElement('tr');
          var canCancel = b.status === 'pending' || b.status === 'confirmed';
          tr.innerHTML = '<td>' + b.booking_date + '</td><td>' + b.booking_time + '</td><td>' + escapeHtml(b.client_name) + '</td><td>' + escapeHtml(b.client_email) + '</td><td>' + escapeHtml(b.service) + '</td><td>' + statusLabel(s, b.status) + '</td>' + (canCancel ? '<td><button class="button button--small" data-admin-cancel="' + b.id + '">' + ((s.bookings && s.bookings.cancel) || 'Cancel') + '</button></td>' : '<td></td>');
          tbody.appendChild(tr);
        });
      } else {
        empty.hidden = false;
      }
    }).catch(function () {
      loading.hidden = true;
      empty.hidden = false;
    });
  }

  load();

  document.getElementById('admin-bookings-search').addEventListener('input', load);
  document.getElementById('admin-bookings-status').addEventListener('change', load);

  document.getElementById('admin-bookings-body').addEventListener('click', function (e) {
    var btn = e.target.closest('[data-admin-cancel]');
    if (!btn) return;
    if (!confirm((s.bookings && s.bookings.cancelConfirm) || 'Cancel this booking?')) return;
    post('/admin/bookings/' + encodeURIComponent(btn.dataset.adminCancel) + '/cancel').then(function () {
      load();
    }).catch(function () {
      alert(s.failed || 'Failed');
    });
  });
}

function initAdminSchedule() {
  var app = document.getElementById('admin-schedule-app');
  if (!app || app._inited) return;
  app._inited = true;
  var s = adminStrings(app);
  var t = s.schedule || {};

  var days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  var dayLabels = t.days || ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var times = [];
  for (var h = 8; h <= 20; h++) {
    times.push((h < 10 ? '0' : '') + h + ':00');
  }

  var ZONES = ['UTC', 'Asia/Jerusalem', 'Europe/London', 'Europe/Berlin', 'Europe/Paris', 'Europe/Moscow', 'Europe/Minsk', 'Europe/Kyiv', 'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'Asia/Dubai', 'Asia/Tokyo', 'Australia/Sydney'];
  function renderTimezones(current) {
    var sel = document.getElementById('admin-timezone');
    if (!sel) return;
    var list = ZONES.slice();
    if (current && list.indexOf(current) === -1) list.unshift(current);
    sel.innerHTML = list.map(function (z) {
      return '<option value="' + z + '"' + (z === current ? ' selected' : '') + '>' + z + '</option>';
    }).join('');
  }

  var schedule = {};

  function renderGrid() {
    var grid = document.getElementById('admin-schedule-grid');
    grid.innerHTML = '';
    var html = '<div class="admin-schedule-grid">';
    html += '<div class="admin-schedule__header"></div>';
    times.forEach(function (time) {
      html += '<div class="admin-schedule__header">' + time + '</div>';
    });
    days.forEach(function (day, di) {
      html += '<div class="admin-schedule__day">' + dayLabels[di] + '</div>';
      times.forEach(function (time) {
        var active = schedule[day] && schedule[day].includes(time);
        html += '<div class="admin-schedule__cell' + (active ? ' is-active' : '') + '" data-day="' + day + '" data-time="' + time + '"></div>';
      });
    });
    html += '</div>';
    grid.innerHTML = html;

    grid.addEventListener('click', function (e) {
      var cell = e.target.closest('.admin-schedule__cell');
      if (!cell) return;
      var day = cell.dataset.day;
      var time = cell.dataset.time;
      if (!schedule[day]) schedule[day] = [];
      var idx = schedule[day].indexOf(time);
      if (idx >= 0) { schedule[day].splice(idx, 1); cell.classList.remove('is-active'); }
      else { schedule[day].push(time); schedule[day].sort(); cell.classList.add('is-active'); }
    });
  }

  get('/admin/schedule').then(function (data) {
    schedule = data.schedule || {};
    renderTimezones(data.timezone || 'UTC');
    renderGrid();
    renderBlocked(data.blocked_dates || []);
  }).catch(function () {
    renderTimezones('UTC');
    renderGrid();
    renderBlocked([]);
  });

  document.getElementById('admin-schedule-save').addEventListener('click', function () {
    var btn = this;
    var status = document.getElementById('admin-schedule-status');
    btn.disabled = true;
    status.textContent = t.saving || 'Saving...';
    put('/admin/schedule', { schedule: schedule, timezone: (document.getElementById('admin-timezone') || {}).value }).then(function () {
      status.textContent = t.saved || 'Saved!'; setTimeout(function () { status.textContent = ''; }, 2000);
      btn.disabled = false;
    }).catch(function () {
      status.textContent = t.failed || 'Failed';
      btn.disabled = false;
    });
  });

  var blockedDates = [];

  function renderBlocked(list) {
    blockedDates = list;
    var el = document.getElementById('admin-blocked-list');
    if (!list.length) { el.innerHTML = '<p style="color:var(--color-text-muted)">' + (t.noBlocked || 'No blocked dates.') + '</p>'; return; }
    el.innerHTML = list.map(function (b) {
      return '<div class="admin-blocked-item"><span>' + b.date + (b.reason ? ' — ' + escapeHtml(b.reason) : '') + '</span><button class="button button--small" data-unblock="' + b.date + '">' + (t.remove || 'Remove') + '</button></div>';
    }).join('');
  }

  document.getElementById('admin-block-add').addEventListener('click', function () {
    var dateInput = document.getElementById('admin-block-date');
    var reasonInput = document.getElementById('admin-block-reason');
    var date = dateInput.value;
    if (!date) return;
    post('/admin/schedule', { action: 'block', date: date, reason: reasonInput.value }).then(function () {
      blockedDates.push({ date: date, reason: reasonInput.value });
      renderBlocked(blockedDates);
      dateInput.value = '';
      reasonInput.value = '';
    }).catch(function () {});
  });

  document.getElementById('admin-blocked-list').addEventListener('click', function (e) {
    var btn = e.target.closest('[data-unblock]');
    if (!btn) return;
    var date = btn.dataset.unblock;
    post('/admin/schedule', { action: 'unblock', date: date }).then(function () {
      blockedDates = blockedDates.filter(function (b) { return b.date !== date; });
      renderBlocked(blockedDates);
    }).catch(function () {});
  });
}

function initAdminClients() {
  var app = document.getElementById('admin-clients-app');
  if (!app || app._inited) return;
  app._inited = true;

  function load() {
    var search = document.getElementById('admin-clients-search').value;
    var loading = document.getElementById('admin-clients-loading');
    var empty = document.getElementById('admin-clients-empty');
    var table = document.getElementById('admin-clients-table');
    var tbody = document.getElementById('admin-clients-body');

    loading.hidden = false;
    table.hidden = true;
    empty.hidden = true;
    tbody.innerHTML = '';

    get('/admin/clients?search=' + encodeURIComponent(search)).then(function (data) {
      loading.hidden = true;
      if (data.clients && data.clients.length) {
        table.hidden = false;
        data.clients.forEach(function (c) {
          var tr = document.createElement('tr');
          tr.innerHTML = '<td>' + escapeHtml(c.client_name) + '</td><td>' + escapeHtml(c.client_email) + '</td><td>' + (c.locale || '') + '</td><td>' + c.booking_count + '</td><td>' + (c.last_booking || '') + '</td><td>' + (c.first_booking || '').slice(0, 10) + '</td>';
          tbody.appendChild(tr);
        });
      } else {
        empty.hidden = false;
      }
    }).catch(function () {
      loading.hidden = true;
      empty.hidden = false;
    });
  }

  load();
  document.getElementById('admin-clients-search').addEventListener('input', load);
}

function initAdminRequests() {
  var app = document.getElementById('admin-requests-app');
  if (!app || app._inited) return;
  app._inited = true;
  var s = adminStrings(app);
  var t = s.requests || {};

  var body = document.getElementById('admin-requests-body');
  var loading = document.getElementById('admin-requests-loading');
  var empty = document.getElementById('admin-requests-empty');
  var table = document.getElementById('admin-requests-table');
  var detail = document.getElementById('admin-request-detail');

  function load() {
    var params = new URLSearchParams({
      status: document.getElementById('admin-requests-status').value,
      search: document.getElementById('admin-requests-search').value
    });
    loading.hidden = false;
    table.hidden = true;
    empty.hidden = true;
    body.innerHTML = '';
    get('/admin/requests?' + params.toString()).then(function (data) {
      loading.hidden = true;
      if (data && data.length) {
        table.hidden = false;
        data.forEach(function (r) {
          var tr = document.createElement('tr');
          tr.innerHTML =
            '<td>' + escapeHtml(r.client_name) + '</td>' +
            '<td>' + escapeHtml(r.client_email) + '</td>' +
            '<td>' + (r.created_at || '').slice(0, 10) + '</td>' +
            '<td>' + escapeHtml(r.experience || '') + '</td>' +
            '<td>' + statusLabel(s, r.status) + '</td>' +
            '<td><button class="button button--small" data-review="' + r.id + '">' + (t.review || 'Review') + '</button></td>';
          body.appendChild(tr);
        });
      } else {
        empty.hidden = false;
      }
    }).catch(function () {
      loading.hidden = true;
      empty.hidden = false;
    });
  }

  var guidesCache = null;
  function guides() {
    if (guidesCache) return Promise.resolve(guidesCache);
    return get('/guides').then(function (data) {
      guidesCache = (data && data.guides) || [];
      return guidesCache;
    });
  }

  function openDetail(id) {
    get('/admin/requests/' + id).then(function (data) {
      var req = data.request;
      var msgs = data.messages || [];
      detail.hidden = false;
      detail.innerHTML =
        '<div class="admin-request-detail__head"><h2>' + (t.detailTitle || 'Request #') + req.id + '</h2>' +
        '<span class="admin-request-detail__status">' + escapeHtml(statusLabel(s, req.status)) + '</span></div>' +
        '<dl class="admin-request-detail__meta">' +
          '<dt>' + (t.client || 'Client') + '</dt><dd>' + escapeHtml(req.client_name) + ' &lt;' + escapeHtml(req.client_email) + '&gt;</dd>' +
          '<dt>' + (t.experience || 'Experience') + '</dt><dd>' + escapeHtml(req.experience || '—') + '</dd>' +
          '<dt>' + (t.story || 'Story') + '</dt><dd>' + escapeHtml(req.story || '—') + '</dd>' +
        '</dl>' +
        '<div class="admin-request-detail__thread">' + msgs.map(function (m) {
          return '<div class="admin-request-msg admin-request-msg--' + m.author + (m.visible_to_client ? '' : ' is-internal') + '">' +
            '<span class="admin-request-msg__author">' + m.author + (m.visible_to_client ? '' : ' ' + (t.internal || '(internal)')) + '</span>' +
            '<p>' + escapeHtml(m.body) + '</p></div>';
        }).join('') + '</div>' +
        '<div class="admin-request-actions">' +
          '<input type="text" id="admin-request-note" class="admin-input" placeholder="' + (t.notePlaceholder || 'Optional note...') + '">' +
          '<label class="admin-request-actions__vis"><input type="checkbox" id="admin-request-note-visible" checked> ' + (t.showToClient || 'show note to client') + '</label>' +
          '<div class="admin-request-actions__row">' +
            '<button class="button button--small" data-req-approve>' + (t.approve || 'Approve') + '</button>' +
            '<button class="button button--small button--secondary" data-req-decline>' + (t.decline || 'Decline') + '</button>' +
          '</div>' +
          '<div class="admin-request-actions__row">' +
            '<input type="text" id="admin-request-info" class="admin-input" placeholder="' + (t.askInfoPlaceholder || 'Ask for more info...') + '">' +
            '<button class="button button--small button--secondary" data-req-info>' + (t.requestInfo || 'Request info') + '</button>' +
          '</div>' +
          '<div class="admin-request-actions__row">' +
            '<select id="admin-request-refer" class="admin-input"></select>' +
            '<button class="button button--small button--secondary" data-req-refer>' + (t.refer || 'Refer') + '</button>' +
          '</div>' +
        '</div>';

      var sel = document.getElementById('admin-request-refer');
      guides().then(function (list) {
        sel.innerHTML = list.filter(function (g) { return g.id !== req.guide_id; })
          .map(function (g) { return '<option value="' + g.id + '">' + escapeHtml(g.name) + '</option>'; }).join('');
      }).catch(function () {});

      function note() { return document.getElementById('admin-request-note').value; }
      function visible() { return document.getElementById('admin-request-note-visible').checked; }
      function done() { detail.hidden = true; load(); }

      detail.querySelector('[data-req-approve]').addEventListener('click', function () {
        post('/admin/requests/' + req.id + '/approve', { note: note(), note_visible: visible() }).then(done).catch(function () {});
      });
      detail.querySelector('[data-req-decline]').addEventListener('click', function () {
        post('/admin/requests/' + req.id + '/decline', { note: note(), note_visible: visible() }).then(done).catch(function () {});
      });
      detail.querySelector('[data-req-info]').addEventListener('click', function () {
        var m = document.getElementById('admin-request-info').value;
        if (!m.trim()) return;
        post('/admin/requests/' + req.id + '/request-info', { message: m }).then(done).catch(function () {});
      });
      detail.querySelector('[data-req-refer]').addEventListener('click', function () {
        var to = document.getElementById('admin-request-refer').value;
        if (!to) return;
        post('/admin/requests/' + req.id + '/refer', { to_guide_id: Number(to), note: note() }).then(done).catch(function () {});
      });
    }).catch(function () {});
  }

  body.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-review]');
    if (btn) openDetail(btn.dataset.review);
  });
  document.getElementById('admin-requests-search').addEventListener('input', load);
  document.getElementById('admin-requests-status').addEventListener('change', load);
  load();
}

function initAdminUsers() {
  var app = document.getElementById('admin-users-app');
  if (!app || app._inited) return;
  app._inited = true;
  var s = adminStrings(app);
  try { s.status = JSON.parse(app.dataset.statusI18n || '{}'); } catch (e) { /* ignore */ }

  var listView = document.getElementById('admin-list-view');
  var detailView = document.getElementById('admin-detail-view');
  var body = document.getElementById('admin-users-body');
  var loading = document.getElementById('admin-loading');
  var empty = document.getElementById('admin-empty');
  var tableWrapper = document.getElementById('admin-table-wrapper');
  var searchInput = document.getElementById('admin-search');
  var backBtn = document.getElementById('admin-back-btn');
  var notesList = document.getElementById('admin-notes-list');
  var currentId = null;

  function load() {
    var search = searchInput ? searchInput.value : '';
    loading.hidden = false;
    empty.hidden = true;
    tableWrapper.hidden = true;
    body.innerHTML = '';

    get('/admin/users?search=' + encodeURIComponent(search)).then(function (data) {
      loading.hidden = true;
      if (data && data.length) {
        tableWrapper.hidden = false;
        body.innerHTML = data.map(function (u) {
          var status = u.anonymized_at ? (s.statusAnonymized || 'Anonymized') : (s.statusActive || 'Active');
          var marketing = u.marketing_consent ? (s.consentYes || 'Y') : (s.consentNo || 'N');
          return '<tr class="admin-user-row" data-user-id="' + u.id + '">' +
            '<td class="admin-user-name">' + escapeHtml(u.name) + '<br><small>' + escapeHtml(status) + '</small></td>' +
            '<td>' + escapeHtml(u.email) + '</td>' +
            '<td>' + escapeHtml(u.role) + '</td>' +
            '<td>' + (u.bookingCount || 0) + '</td>' +
            '<td>' + (u.created_at || '').slice(0, 10) + '</td>' +
            '<td>' + escapeHtml(marketing) + '</td>' +
          '</tr>';
        }).join('');
      } else {
        empty.hidden = false;
      }
    }).catch(function () {
      loading.hidden = true;
      empty.hidden = false;
    });
  }

  function renderNotes(notes) {
    var noNotes = document.getElementById('admin-no-notes');
    if (!notes || !notes.length) {
      noNotes.hidden = false;
      notesList.innerHTML = '';
      return;
    }
    noNotes.hidden = true;
    notesList.innerHTML = notes.map(function (n) {
      return '<div class="admin-note" data-note-id="' + n.id + '">' +
        '<div class="admin-note__meta">' +
          '<span class="admin-note__author">' + escapeHtml(n.author_name) + '</span>' +
          '<span class="admin-note__date">' + escapeHtml((n.created_at || '').slice(0, 10)) + '</span>' +
          '<button type="button" class="admin-note__delete" data-delete-note="' + n.id + '" title="' + escapeHtml(s.deleteNote || 'Delete note') + '">&times;</button>' +
        '</div>' +
        '<div class="admin-note__content">' + escapeHtml(n.content) + '</div>' +
      '</div>';
    }).join('');
  }

  function showDetail(id) {
    currentId = id;
    listView.hidden = true;
    detailView.hidden = false;
    get('/admin/users/' + encodeURIComponent(id)).then(function (data) {
      var u = data.user;
      var rows = [
        [s.tableName, u.name],
        [s.tableEmail, u.email],
        [s.roleLabel, roleLabel(s, u.role)],
        [s.localeLabel, u.locale],
        [s.marketingLabel, u.marketing_consent ? s.consentYes : s.consentNo],
        [s.sinceLabel, (u.created_at || '').slice(0, 10)]
      ];
      document.getElementById('admin-profile-dl').innerHTML = rows.map(function (r) {
        return '<dt>' + escapeHtml(r[0] || '') + '</dt><dd>' + escapeHtml(r[1] == null ? '' : String(r[1])) + '</dd>';
      }).join('');

      // Role control — never allow changing your own role (lockout protection).
      var roleSelect = document.getElementById('admin-role-select');
      var roleSave = document.getElementById('admin-role-save');
      var roleStatus = document.getElementById('admin-role-status');
      if (roleStatus) roleStatus.textContent = '';
      if (roleSelect) { roleSelect.value = u.role; roleSelect.disabled = false; }
      if (roleSave) roleSave.disabled = false;
      getSession().then(function (me) {
        if (me && String(me.id) === String(id)) {
          if (roleSelect) roleSelect.disabled = true;
          if (roleSave) roleSave.disabled = true;
          if (roleStatus) roleStatus.textContent = s.roleSelfNote || '';
        }
      });

      var bBody = document.getElementById('admin-bookings-body');
      var noBookings = document.getElementById('admin-no-bookings');
      var bWrap = document.getElementById('admin-bookings-wrapper');
      if (data.bookings && data.bookings.length) {
        noBookings.hidden = true;
        bWrap.hidden = false;
        bBody.innerHTML = data.bookings.map(function (bk) {
          return '<tr><td>' + escapeHtml(bk.booking_date) + '</td><td>' + escapeHtml(bk.booking_time) + '</td><td>' + escapeHtml(bk.service) + '</td><td>' + escapeHtml(statusLabel(s, bk.status)) + '</td></tr>';
        }).join('');
      } else {
        noBookings.hidden = false;
        bWrap.hidden = true;
        bBody.innerHTML = '';
      }
      renderNotes(data.notes);
    }).catch(function () {
      detailView.hidden = true;
      listView.hidden = false;
      currentId = null;
    });
  }

  if (body) {
    body.addEventListener('click', function (e) {
      var row = e.target.closest('[data-user-id]');
      if (row) showDetail(row.dataset.userId);
    });
  }

  if (searchInput) {
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(load, 300);
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      detailView.hidden = true;
      listView.hidden = false;
      currentId = null;
    });
  }

  if (notesList) {
    notesList.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-delete-note]');
      if (!btn || !currentId) return;
      if (!confirm(s.deleteConfirm || 'Delete this note?')) return;
      del('/admin/users/' + encodeURIComponent(currentId) + '/notes/' + encodeURIComponent(btn.dataset.deleteNote)).then(function () {
        var noteEl = btn.closest('.admin-note');
        if (noteEl) noteEl.remove();
        if (!notesList.children.length) document.getElementById('admin-no-notes').hidden = false;
      }).catch(function () {});
    });
  }

  var saveBtn = document.getElementById('admin-note-save');
  if (saveBtn) {
    saveBtn.addEventListener('click', function () {
      var input = document.getElementById('admin-note-input');
      var content = input.value.trim();
      if (!content || !currentId) return;
      saveBtn.disabled = true;
      post('/admin/users/' + encodeURIComponent(currentId) + '/notes', { content: content })
        .then(function () {
          input.value = '';
          return get('/admin/users/' + encodeURIComponent(currentId));
        })
        .then(function (data) { if (data) renderNotes(data.notes); })
        .catch(function () {})
        .finally(function () { saveBtn.disabled = false; });
    });
  }

  var roleSaveBtn = document.getElementById('admin-role-save');
  if (roleSaveBtn) {
    roleSaveBtn.addEventListener('click', function () {
      var select = document.getElementById('admin-role-select');
      var status = document.getElementById('admin-role-status');
      if (!currentId || !select) return;
      var role = select.value;
      if (role !== 'user' && role !== 'admin') return;
      if (!confirm(s.roleConfirm || "Change this user's role?")) return;
      roleSaveBtn.disabled = true;
      put('/admin/users/' + encodeURIComponent(currentId) + '/role', { role: role }).then(function () {
        if (status) status.textContent = s.roleSaved || 'Role updated';
        var dl = document.getElementById('admin-profile-dl');
        var dds = dl ? dl.querySelectorAll('dd') : [];
        if (dds[2]) dds[2].textContent = roleLabel(s, role);
        load();
      }).catch(function (err) {
        if (status) status.textContent = (err && err.message) || '';
      }).finally(function () { roleSaveBtn.disabled = false; });
    });
  }

  load();
}

function escapeHtml(str) {
  if (!str) return '';
  var div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

document.addEventListener('page:load', function () {
  initAdminApp();
  initAdminBookings();
  initAdminSchedule();
  initAdminClients();
  initAdminRequests();
  initAdminUsers();
});
